export const DAILY_CLOSING_TITLE = 'Configuración de Cierre Automático';
export const CLOSING_HOUR = 'Hora de Cierra';
export const SELECT = 'Seleccione';
export const HOUR = 'Hora';
export const MINUTE = 'Minuto';
export const SAVE = 'Guardar';
export const DAILY_CLOSING_SAVED = 'Se ha configurado correctamente la hora de cierre';
export const DAILY_CLOSING_FAIL = 'Hubo un problema al configurar la hora de cierre';
export const FETCH_DAILY_CLOSING_FAIL = 'Hubo un problema al cargar la hora de cierre';
